import { useQuery } from "@tanstack/react-query";
import { ProviderSearchData } from "../api/provider.type";
import { searchProvidersApi } from "../api/provider.public.api";

export function useSearchProviders(q: string) {
  return useQuery<ProviderSearchData>({
    queryKey: ["providers", "search", { q }],
    // Only fire when query has 2+ non-space chars
    enabled: q.trim().length >= 2,
    queryFn: () =>
      searchProvidersApi({
        q: q.trim(),
        limit: 20,
        cursor: 0,
      }),
  });
}
